import { Link } from "react-router-dom";
import { categories } from "@/mocks/site";

export default function CategoryQuick() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="flex items-end justify-between mb-6 md:mb-8">
        <div>
          <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950">
            动漫分类快捷入口
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            按类型快速找到你想看的作品
          </p>
        </div>
        <Link
          to="/anime"
          className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          全部作品
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.name}
            to={`/anime?type=${encodeURIComponent(cat.name)}`}
            className="group flex flex-col items-center justify-center gap-2 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
          >
            <span className="w-12 h-12 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${cat.icon} text-2xl`}></i>
            </span>
            <span className="font-heading font-semibold text-sm text-foreground-950">
              {cat.name}
            </span>
            <span className="text-[11px] text-foreground-500 text-center">{cat.desc}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}